<header class="transparent main_menu" [ngClass]="{'sticky': isSticky}">

    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <nav class="navbar navbar-expand-lg navbar-light">
                    <a class="navbar-brand" routerLink="/"> <img
                        [src]="helper.adminSettings?.logoImage ? helper.imageUrl + helper.adminSettings?.logoImage : helper.DEFAULT_LOGO"
                             alt="logo"> </a>
                    <div class="collapse navbar-collapse main-menu-item justify-content-center"
                        [ngClass]=" isNavbar == true ? 'show' : '' " id="navbarNav">
                        <ul class="navbar-nav">
                            <li class="nav-item">
                              <a
                                class="nav-link"
                                routerLink="/"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }"
                                (click)="isNavbar = false"
                              >
                                {{ 'label-title.home' | translate }}
                                <span class="sr-only">(current)</span>
                              </a>
                            </li>
                            <li class="nav-item">
                              <a
                                class="nav-link"
                                routerLink="/product"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }"
                                id="navbarDropdown"
                                (click)="isNavbar = false"
                                role="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                {{ 'heading-title.product' | translate }}
                              </a>
                            </li>
                            <li class="nav-item">
                              <a
                                class="nav-link"
                                routerLink="/contact-us"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }"
                                (click)="isNavbar = false"
                              >
                                {{ 'label-title.contact-us' | translate }}
                              </a>
                            </li>
                            <li class="nav-item">
                              <a
                                class="nav-link"
                                routerLink="/about"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }"
                                (click)="isNavbar = false"
                              >
                                {{ 'label-title.about-us' | translate }}
                              </a>
                            </li>
                          </ul>
                    </div>
                    <div class="btn_1 btn_seondary d-none d-lg-block me-3 c-pointer" *ngIf="!isLogin"
                        (click)="onRegister()">
                        {{'button-title.register' | translate}}
                    </div>
                    <div class="d-flex">
                        <a routerLink="/app/cart" class="cart-link me-2" [title]="'heading-title.cart' | translate">
                            <span class="cart-link__icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <circle cx="9" cy="21" r="1"></circle>
                                    <circle cx="20" cy="21" r="1"></circle>
                                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                                </svg>
                                <span class="cart-link__badge" *ngIf="cartItemCount > 0">{{ cartItemCount }}</span>
                            </span>
                        </a>
                        <a href="javascript:;">
                            <button class="btn_1 c-pointer" *ngIf="!isLogin" (click)="login()">{{'button-title.login' |
                                translate}}</button>
                            <div class="profile-btn" *ngIf="isLogin" ngbDropdown>
                                <div ngbDropdownToggle id="dropdownBasic1" class="btn_1 d-flex align-items-center ">
                                    <span class="truncate-line-1 text-center" style="width: 85px; ">{{loginUser?.firstName | titlecase}} </span>
                              </div>
                                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                    <a ngbDropdownItem routerLink="/app/profile">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"
                                            _ngcontent-ng-c4224083166="">
                                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                            <circle cx="12" cy="7" r="4"></circle>
                                        </svg> {{'label-title.profile' | translate}}</a>
                                    <a ngbDropdownItem routerLink="/app/orders">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="feather feather-list"
                                            _ngcontent-ng-c4224083166="">
                                            <line x1="8" y1="6" x2="21" y2="6"></line>
                                            <line x1="8" y1="12" x2="21" y2="12"></line>
                                            <line x1="8" y1="18" x2="21" y2="18"></line>
                                            <line x1="3" y1="6" x2="3.01" y2="6"></line>
                                            <line x1="3" y1="12" x2="3.01" y2="12"></line>
                                            <line x1="3" y1="18" x2="3.01" y2="18"></line>
                                        </svg> {{ 'label-title.my-orders' | translate }}</a>
                                    <button ngbDropdownItem (click)="logout()"> <svg xmlns="http://www.w3.org/2000/svg"
                                            width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="feather feather-log-out" _ngcontent-ng-c4224083166="">
                                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                            <polyline points="16 17 21 12 16 7"></polyline>
                                            <line x1="21" y1="12" x2="9" y2="12"></line>
                                        </svg> {{'button-title.sign-out' | translate}}</button>
                                </div>
                            </div>
                        </a>
                        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
                            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation"
                            fdprocessedid="nt9x37" (click)="navToggle()">
                            <span class="navbar-toggler-icon"></span>
                        </button>
                    </div>
                </nav>
            </div>
        </div>
    </div>


</header>

<app-auth #authModel></app-auth>
<app-user-profile-modal #profileModal></app-user-profile-modal>

<!-- <ng-template #logout_popup let-modal>
    <div class="modal-body text-center">
        <h4 class="modal-title mb-3 mt-0" id="modal-basic-title"></h4>
        <p class="mb-3">{{ 'paragraph-title.are-you-sure-you-want-to-log-out' | translate }}</p>
        <div>
            <button class="btn_1 btn_seondary px-3 me-2" (click)="close()">No</button>
            <button class="btn_1 px-3" (click)="confirm()">Yes</button>
        </div>
    </div>
</ng-template> -->
